import {
  languageImports as demographicsLanguages,
  DTranslationKeys,
} from "./demographics";
import {
  languageImports as localContentLanguages,
  LCTranslationKeys,
} from "./local-content";
import { Locales } from "./types";

// TODO Deprecate and delete
export const sdkLocales = {
  "local-content": (language: Locales) => localContentLanguages[language](),
  "local-content-google-maps": (language: Locales) =>
    localContentLanguages[language](),
  demographics: (language: Locales) => demographicsLanguages[language](),
  "local-profiles": (language: Locales) => localContentLanguages[language](),
  "local-neighbourhood-map": (language: Locales) =>
    localContentLanguages[language](),
  "local-neighbourhood-map-google-maps": (language: Locales) =>
    localContentLanguages[language](),
  "local-neighborhood-characteristics": (language: Locales) =>
    localContentLanguages[language](),
  "local-neighborhood-highlights": (language: Locales) =>
    localContentLanguages[language](),
  "local-neighborhood-hero": (language: Locales) =>
    localContentLanguages[language](),
  "local-neighborhood-demographics": (language: Locales) =>
    localContentLanguages[language](),
};

export type { LCTranslationKeys, DTranslationKeys };
